module.exports = __webpack_public_path__ + "img/career-b5.2ffd700a.jpg";